import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=38de822c&scoped=true"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
import style0 from "./Verify.vue?vue&type=style&index=0&id=38de822c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de822c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38de822c')) {
      api.createRecord('38de822c', component.options)
    } else {
      api.reload('38de822c', component.options)
    }
    module.hot.accept("./Verify.vue?vue&type=template&id=38de822c&scoped=true", function () {
      api.rerender('38de822c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauth/Verify.vue"
export default component.exports